<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="">Casi clinici</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Lista</li>
        </ol>

        <LoadedComponent :loading="loading" />
        <div class="pt-2 pl-2 mb-4" v-if="!loading">
          <router-link to="/casi-clinici/nuovo-caso-clinico" class="btn btn-primary custom-primary">Aggiungi caso
            clinico</router-link>

          <router-link to="/casi-clinici/bozze" class="btn btn-info ml-2">Bozze</router-link>
        </div>
        <div></div>

        <div class="col-sm-12 mt-4" v-if="!loading">
          <div class="mb-2">
            <AlertComponent :message="successMessage" :alert-type="'success'" />
          </div>
          <div class="mb-2">
            <AlertComponent :message="errorMessage" :alert-type="'danger'" />
          </div>

          <div class="row">
            <FilterComponent :activities="originalActivities" @setActivities="setActivities" :patologies="patologies"
              :categoryMedicals="categoryMedicals" :anatomicalDistricts="anatomicalDistricts"
              v-on:update:filteredPatologies="updatePatologies"
              v-on:update:filteredCategoryMedicals="updateCategoryMedicals" v-on:update:filteredAnatomicalDistricts="
                updateAnatomicalDistricts
              " category="1" :permission="true"></FilterComponent>
            <div class="col-lg-9" v-if="activities.length > 0">
              <article v-for="(clinicalCase, index) in activities" :key="index" :class="clinicalCase.class">
                <div class="row align-items-center p-4">
                  <div class="col-md-7">
                    <div class="alert alert-success d-none">
                      <h5 class="cipriani-status-message" v-if="clinicalCase.shows">
                        Questo caso clinico è un corso formativo a numero
                        chiuso.
                      </h5>
                    </div>

                    <div class="entry-body">
                      <div class="entry-meta">
                        <span class="entry-author" v-if="clinicalCase.anonymous">Caso anonimo</span>
                        <span class="entry-author" v-if="!clinicalCase.anonymous">{{ clinicalCase.full_name }}</span>
                        <span class="meta-separator">|</span>
                        {{
                          clinicalCase.publish_date
                        }}

                        <span class="meta-separator">|</span>
                        {{
                          clinicalCase.hospital
                        }}
                      </div>

                      <h2 class="entry-title">
                        {{
                          clinicalCase.name
                        }}
                      </h2>

                      <div class="entry-cats">
                        {{
                          clinicalCase.category_medical }}
                      </div>
                      <!-- End .entry-cats -->
                      <!-- End .entry-title -->

                      <div class="entry-content">
                        <p v-if="clinicalCase.company" class="text-danger">
                          Azienda promotrice: &nbsp;
                          <strong>{{ clinicalCase.company }}</strong>
                        </p>
                        <p>{{ clinicalCase.short_description }} ...</p>
                        <router-link :to="'/casi-clinici/show/' + clinicalCase.slug"
                          class="read-more open_page">Continua a leggere</router-link>
                      </div>
                      <!-- End .entry-content -->
                    </div>
                  </div>
                  <div class="col-md-5 d-flex justify-content-center">
                    <img v-if="clinicalCase?.cover" :src="clinicalCase?.cover?.path" class="img-fluid"
                      alt="image desc" />
                    <!-- -->
                    <img v-else
                      src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg"
                      class="img-fluid" alt="image desc" />

                    <!-- End .entry-media -->
                  </div>
                </div>
              </article>
              <hr />
              <div>
                <ul class="pagination">
                  <li class="page-item" v-if="currentPage > 1" @click="goToPage(currentPage - 1)">
                    Indietro
                  </li>
                  <li class="page-item" v-for="page in pages" :key="page" @click="goToPage(page)">
                    <a class="page-link" :class="{ active: currentPage === page }" href="#">{{ page }}</a>
                  </li>
                  <li class="page-item" v-if="currentPage < numberOfPages" @click="goToPage(currentPage + 1)">
                    <a class="page-link" href="#">Avanti</a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-9" v-else>
              <p>Nessun risultato</p>
            </div>

            <!-- End .col-lg-3 -->

            <!-- End .col-md-5 -->
          </div>
        </div>
      </div>
      <!-- End .container -->
    </nav>
    <!-- End .breadcrumb-nav -->
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import FilterComponent from "@/components/FilterComponent.vue";
import httpservices from "@/services/httpservices.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "ClinicalCasePage",
  props: {},
  components: {
    LoadedComponent,
    AlertComponent,
    FilterComponent,
  },
  setup() {
    const auth = useAuth();
    return auth;
  },
  data() {
    return {
      activities: [],
      originalActivities: [],
      loading: true,
      successMessage: "",
      itemsPerPage: 5,
      errorMessage: "",
      currentPage: 1,
      patologies: [],
      categoryMedicals: [],
      anatomicalDistricts: [],
      filteredPatologies: [],
      filteredCategoryMedicals: [],
      filteredAnatomicalDistricts: [],
    };
  },
  mounted() { },
  created() {
    console.log(this.paginatedItems);
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.originalActivities.length / this.itemsPerPage);
    },
    pages() {
      let pages = [];
      for (let i = 1; i <= this.numberOfPages; i++)
      {
        pages.push(i);
      }

      return pages;
    },
    paginatedItems() {
      let start = (this.currentPage - 1) * this.itemsPerPage;
      return this.activities.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    setActivities(value) {
      this.activities = value;
    },
    goToPage(page) {
      this.currentPage = page;
      const original = this.originalActivities;
      let start = (this.currentPage - 1) * this.itemsPerPage;
      this.activities = original.slice(start, start + this.itemsPerPage);
    },
    updatePatologies(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.patology_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.patologies);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.patology_id)
        );
      }
    },
    updateCategoryMedicals(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.category_medical_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.categoryMedicals);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.category_medical_id)
        );
      }
    },
    updateAnatomicalDistricts(selectedCategories) {
      if (selectedCategories.length > 0)
      {
        this.activities = this.originalActivities.filter((item) =>
          selectedCategories.includes(item.anatomical_district_id)
        );
      } else
      {
        const roots = this.mappingOriginalArray(this.anatomicalDistricts);
        this.activities = this.originalActivities.filter((item) =>
          roots.includes(item.anatomical_district_id)
        );
      }
    },
    mappingOriginalArray(originalArray) {
      return originalArray.map((item) => item.id);
    },

    async loadActivity() {
      await httpauth
        .get("/casi-clinici/all")
        .then((response) => {
          var data = response.data.data;

          this.originalActivities = data.map((oggetto) => {
            const companyId = oggetto.company_id;
            const classe =
              companyId === null
                ? "entry entry-list mb-2 mb-md-3 p-2"
                : "entry entry-list mb-2 mb-md-3 bg-light border border-2  border-danger rounded p-2";
            return { ...oggetto, class: classe };
          });

          let start = (this.currentPage - 1) * this.itemsPerPage;
          const app = this.originalActivities.slice(
            start,
            start + this.itemsPerPage
          );
          this.activities = app;

          this.loading = false;

          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          console.log(error);
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedicals = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistricts = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  beforeMount() {
    let successMessage = localStorage.getItem("messageSuccessClinicalCase");
    if (successMessage)
    {
      const $toast = useToast();
      $toast.open({
        message: successMessage,
        type: "info",
        position: "top-right",
        // all of other options may go here
      });
      localStorage.removeItem("messageSuccessClinicalCase");
    }

    let errorMessage = localStorage.getItem("messageErrorClinicalCase");
    if (errorMessage)
    {
      const $toast = useToast();
      $toast.open({
        message: errorMessage,
        type: "info",
        position: "top-right",
        // all of other options may go here
      });
      localStorage.removeItem("messageErrorClinicalCase");
    }

    this.loadActivity();
    this.fetchCategoryMedical();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
  },
};
</script>
<style scoped>
.border-2 {
  border: 3.5px solid red !important;
}
</style>